module.exports = __webpack_public_path__ + "img/94.04754546.jpg";